import { cva } from '@/styled-system/css';

export const avatarIconRecipe = cva({
  base: {},
  variants: {
    tone: {
      'default': {
        color: 'Avatar.Icon.default',
      },
      'brand-hero': {
        color: 'Avatar.Icon.brand.hero',
      },
      'accent-1': {
        color: 'Avatar.Icon.accent-1',
      },
      'accent-2': {
        color: 'Avatar.Icon.accent-2',
      },
      'accent-3': {
        color: 'Avatar.Icon.accent-3',
      },
      'accent-4': {
        color: 'Avatar.Icon.accent-4',
      },
    },
    size: {
      xs: {
        width: 'Avatar.Icon.xs',
        height: 'Avatar.Icon.xs',
      },
      sm: {
        width: 'Avatar.Icon.sm',
        height: 'Avatar.Icon.sm',
      },
      md: {
        width: 'Avatar.Icon.md',
        height: 'Avatar.Icon.md',
      },
      lg: {
        width: 'Avatar.Icon.lg',
        height: 'Avatar.Icon.lg',
      },
      xl: {
        width: 'Avatar.Icon.xl',
        height: 'Avatar.Icon.xl',
      },
      xxl: {
        width: 'Avatar.Icon.xxl',
        height: 'Avatar.Icon.xxl',
      },
    },
  },
});
